// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediosDigitales_container__O0BTr .MediosDigitales_content__NTJ1I {
  justify-content: center;
  align-items: center;
}

.MediosDigitales_container__O0BTr .MediosDigitales_content__NTJ1I .MediosDigitales_bankContainer__KDWq1 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15%;
}

.MediosDigitales_depositContainer__UXUc5 {
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.MediosDigitales_itemTitle__ePwJN {
  font-size: 1rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 2px;
}

.MediosDigitales_money__VVd6\\+ {
  font-size: 1.2rem;
  font-weight: lighter;
  background-color: white;
  padding: 5px;
  border-radius: 5px;
  text-align: center;
  margin-bottom: 2px;
}

.MediosDigitales_iconOptions__i5bbU {
  transition: 0.3s;
}

.MediosDigitales_iconOptions__i5bbU:hover {
  scale: 1.03;
  filter: brightness(0.6);
  transition: 0.3s;
  cursor: pointer;
}

.MediosDigitales_qr__nnmGn {
  text-align: center;
}

.MediosDigitales_title__Kuu5I {
  justify-content: flex-start;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-left: 1px;
  font-size: 1.7em;
}

.MediosDigitales_date__Y2BdF {
  scale: 1;
  width: 100%;
  text-align: start;
}

.MediosDigitales_inputationDate__SjVGK {
  font-size: 1rem;
}

.MediosDigitales_pagination__c2Tu7 {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 40px;
  width: 100%;
}

.MediosDigitales_container__O0BTr .MediosDigitales_content__NTJ1I .MediosDigitales_noAgencieSelected__AcXQX {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.MediosDigitales_container__O0BTr .MediosDigitales_content__NTJ1I .MediosDigitales_noAgencieSelected__AcXQX h3 {
  font-size: 32px;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-top: 10%;
}

.MediosDigitales_container__O0BTr .MediosDigitales_content__NTJ1I .MediosDigitales_noAgencieSelected__AcXQX .MediosDigitales_redirectBtn__xQ2lC {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  width: 20%;
  border-radius: 10px;
  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.298);
}

.MediosDigitales_container__O0BTr .MediosDigitales_content__NTJ1I .MediosDigitales_noAgencieSelected__AcXQX .MediosDigitales_redirectBtn__xQ2lC:hover {
  transition: 0.3s;
  cursor: pointer;
  scale: 1.06;
  filter: brightness(1.3);
  box-shadow: 0px 0px 15px -3px rgba(255, 255, 255, 0.298);
}
.MediosDigitales_container__O0BTr .MediosDigitales_selectAgency__jDzEH {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* New styles */

.MediosDigitales_container__O0BTr {
  animation: MediosDigitales_init__PmcwK 1s;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

/*--Header--*/
.MediosDigitales_container__O0BTr .MediosDigitales_header__jLyux {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 75vh;
  border-radius: 25px;
}

.MediosDigitales_container__O0BTr .MediosDigitales_header__jLyux .MediosDigitales_titleContainer__i8BD3 {
  animation: MediosDigitales_init2__5uq-Y 0.3s both;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.MediosDigitales_container__O0BTr .MediosDigitales_header__jLyux .MediosDigitales_titleContainer__i8BD3 h4 {
  text-align: center;
  font-size: 1.6rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-left: 10px;
}

.MediosDigitales_container__O0BTr .MediosDigitales_header__jLyux .MediosDigitales_titleContainer__i8BD3 .MediosDigitales_add_btn__uQ-RX {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.5rem;
  width: 6.5rem;
  text-transform: capitalize;
  border-radius: 5px;
  font-size: 1rem;
  font-weight: 300;
  font-family: Roboto, sans-serif;
  margin-left: 10px;
}

.MediosDigitales_container__O0BTr .MediosDigitales_filters__eZTNW {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.MediosDigitales_filterButton__D7wAq {
  animation: MediosDigitales_init3__zSJCE 0.3s both;
  height: 3rem;
  width: 10rem;
  margin-left: 5px;
  margin-bottom: 10px;
  border-radius: 5px;
}

.MediosDigitales_filterButton__D7wAq p {
  text-transform: capitalize;
  margin-left: 5px;
  font-weight: 400;
}

.MediosDigitales_container__O0BTr .MediosDigitales_tableContainer__Op2cP {
  animation: MediosDigitales_init3__zSJCE 0.3s both;
  width: 100%;
  border-radius: 5px;
  /*box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.168);*/
}

.MediosDigitales_container__O0BTr .MediosDigitales_loader__mylQf {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

@keyframes MediosDigitales_init__PmcwK {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes MediosDigitales_init2__5uq-Y {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}

@keyframes MediosDigitales_init3__zSJCE {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}

@media print {
  .MediosDigitales_titleContainer__i8BD3 {
    display: none !important;
  }
  .MediosDigitales_header__jLyux {
    display: none !important;
  }
  .MediosDigitales_filters__eZTNW {
    display: none !important;
  }
  .MediosDigitales_filterButton__D7wAq {
    display: none !important;
  }
  .MediosDigitales_selectAgency__jDzEH {
    display: none !important;
  }
  .MediosDigitales_bankContainer__KDWq1 {
    display: none !important;
  }
  .MediosDigitales_icon__g5vvU {
    display: none !important;
  }
  .MediosDigitales_optionButton__cfruE {
    display: none !important;
  }
  .MediosDigitales_optionsContainer__5o0xQ {
    display: none !important;
  }
  .MediosDigitales_pagination__c2Tu7 {
    display: none !important;
  }
  .MediosDigitales_noResultContainer__wpGup {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/MediosDigitales/index.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,wDAAwD;AAC1D;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,eAAe;;AAEf;EACE,yCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iDAA0B;EAC1B,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iDAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iDAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".container .content {\n  justify-content: center;\n  align-items: center;\n}\n\n.container .content .bankContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 15%;\n}\n\n.depositContainer {\n  padding: 10px;\n  border-radius: 10px;\n  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);\n}\n\n.itemTitle {\n  font-size: 1rem;\n  font-weight: bold;\n  text-align: center;\n  margin-bottom: 2px;\n}\n\n.money {\n  font-size: 1.2rem;\n  font-weight: lighter;\n  background-color: white;\n  padding: 5px;\n  border-radius: 5px;\n  text-align: center;\n  margin-bottom: 2px;\n}\n\n.iconOptions {\n  transition: 0.3s;\n}\n\n.iconOptions:hover {\n  scale: 1.03;\n  filter: brightness(0.6);\n  transition: 0.3s;\n  cursor: pointer;\n}\n\n.qr {\n  text-align: center;\n}\n\n.title {\n  justify-content: flex-start;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-left: 1px;\n  font-size: 1.7em;\n}\n\n.date {\n  scale: 1;\n  width: 100%;\n  text-align: start;\n}\n\n.inputationDate {\n  font-size: 1rem;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-top: 40px;\n  padding-bottom: 40px;\n  width: 100%;\n}\n\n.container .content .noAgencieSelected {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .content .noAgencieSelected h3 {\n  font-size: 32px;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-top: 10%;\n}\n\n.container .content .noAgencieSelected .redirectBtn {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n  width: 20%;\n  border-radius: 10px;\n  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.298);\n}\n\n.container .content .noAgencieSelected .redirectBtn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  scale: 1.06;\n  filter: brightness(1.3);\n  box-shadow: 0px 0px 15px -3px rgba(255, 255, 255, 0.298);\n}\n.container .selectAgency {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n/* New styles */\n\n.container {\n  animation: init 1s;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n/*--Header--*/\n.container .header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 75vh;\n  border-radius: 25px;\n}\n\n.container .header .titleContainer {\n  animation: init2 0.3s both;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  text-align: center;\n  font-size: 1.6rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-left: 10px;\n}\n\n.container .header .titleContainer .add_btn {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 2.5rem;\n  width: 6.5rem;\n  text-transform: capitalize;\n  border-radius: 5px;\n  font-size: 1rem;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n  margin-left: 10px;\n}\n\n.container .filters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.filterButton {\n  animation: init3 0.3s both;\n  height: 3rem;\n  width: 10rem;\n  margin-left: 5px;\n  margin-bottom: 10px;\n  border-radius: 5px;\n}\n\n.filterButton p {\n  text-transform: capitalize;\n  margin-left: 5px;\n  font-weight: 400;\n}\n\n.container .tableContainer {\n  animation: init3 0.3s both;\n  width: 100%;\n  border-radius: 5px;\n  /*box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.168);*/\n}\n\n.container .loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes init2 {\n  0% {\n    opacity: 0;\n    transform: translateX(-100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n}\n\n@keyframes init3 {\n  0% {\n    opacity: 0;\n    transform: translateX(100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n}\n\n@media print {\n  .titleContainer {\n    display: none !important;\n  }\n  .header {\n    display: none !important;\n  }\n  .filters {\n    display: none !important;\n  }\n  .filterButton {\n    display: none !important;\n  }\n  .selectAgency {\n    display: none !important;\n  }\n  .bankContainer {\n    display: none !important;\n  }\n  .icon {\n    display: none !important;\n  }\n  .optionButton {\n    display: none !important;\n  }\n  .optionsContainer {\n    display: none !important;\n  }\n  .pagination {\n    display: none !important;\n  }\n  .noResultContainer {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MediosDigitales_container__O0BTr`,
	"content": `MediosDigitales_content__NTJ1I`,
	"bankContainer": `MediosDigitales_bankContainer__KDWq1`,
	"depositContainer": `MediosDigitales_depositContainer__UXUc5`,
	"itemTitle": `MediosDigitales_itemTitle__ePwJN`,
	"money": `MediosDigitales_money__VVd6+`,
	"iconOptions": `MediosDigitales_iconOptions__i5bbU`,
	"qr": `MediosDigitales_qr__nnmGn`,
	"title": `MediosDigitales_title__Kuu5I`,
	"date": `MediosDigitales_date__Y2BdF`,
	"inputationDate": `MediosDigitales_inputationDate__SjVGK`,
	"pagination": `MediosDigitales_pagination__c2Tu7`,
	"noAgencieSelected": `MediosDigitales_noAgencieSelected__AcXQX`,
	"redirectBtn": `MediosDigitales_redirectBtn__xQ2lC`,
	"selectAgency": `MediosDigitales_selectAgency__jDzEH`,
	"init": `MediosDigitales_init__PmcwK`,
	"header": `MediosDigitales_header__jLyux`,
	"titleContainer": `MediosDigitales_titleContainer__i8BD3`,
	"init2": `MediosDigitales_init2__5uq-Y`,
	"add_btn": `MediosDigitales_add_btn__uQ-RX`,
	"filters": `MediosDigitales_filters__eZTNW`,
	"filterButton": `MediosDigitales_filterButton__D7wAq`,
	"init3": `MediosDigitales_init3__zSJCE`,
	"tableContainer": `MediosDigitales_tableContainer__Op2cP`,
	"loader": `MediosDigitales_loader__mylQf`,
	"icon": `MediosDigitales_icon__g5vvU`,
	"optionButton": `MediosDigitales_optionButton__cfruE`,
	"optionsContainer": `MediosDigitales_optionsContainer__5o0xQ`,
	"noResultContainer": `MediosDigitales_noResultContainer__wpGup`
};
export default ___CSS_LOADER_EXPORT___;
